// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"bff0319f","389":"4957c547","455":"e7869f39","857":"c74456ae","977":"8c578846"}[chunkId] + ".chunk.js";
};